import { BaseModel } from '../base.model'
import { SectionGrade } from './section-grade.model'
import { Question } from 'models/question.model'


  
export class ExamSection extends BaseModel<ExamSection> {
  static DEFAULT_ATTRIBUTES = {
    questionIds: [],
    grades: [new SectionGrade({ minScore: 0 })]
  }

  id: number
  examId: number
  sectionId: number
  factor: number
  shuffleQuestions: boolean
  questionsCount: number
  amountForShow: number
  _destroy: boolean
  questionIds: number[]
  blocking: boolean
  grades: SectionGrade[]
  questions: Question[]

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/exams/exam-section.model.ts